// @flow
import type { ImagePositionType } from 'app/common/react/components/profile/ProfileBoardCard/commonTypes';
import type { Thunk } from 'app/common/redux/types';
import { resourceFetch } from 'app/common/redux/actions/resourceFetch';

export type BoardUpdatePinCount = {
  type: 'BOARD_UPDATE_PIN_COUNT',
  payload: {
    boardId: string,
  },
};

export const updateBoardWithFieldSetKey = (boardId: string, fieldSetKey: string): Thunk<void> => (
  dispatch,
) =>
  // The normal resource reducers will run after the resource fetch
  dispatch(resourceFetch('BoardResource', { board_id: boardId, field_set_key: fieldSetKey }));

export const updatePinCount = (boardId: string): Thunk<void> =>
  // The normal resource reducers will run after the resource fetch
  updateBoardWithFieldSetKey(boardId, 'pin_count');

type BoardPinCountChangedPayload = {
  boardId: string,
  sectionId: ?string,
  increment: number,
};

export type BoardPinCountChanged = {
  type: 'BOARD_PIN_COUNT_CHANGED',
  payload: BoardPinCountChangedPayload,
};

export const boardPinCountChanged = (
  payload: BoardPinCountChangedPayload,
): BoardPinCountChanged => ({
  type: 'BOARD_PIN_COUNT_CHANGED',
  payload,
});

export type BoardInviteAcceptedByViewer = {
  type: 'BOARD_INVITE_ACCEPTED_BY_VIEWER',
  payload: {
    boardId: string,
  },
};

export const boardInviteAcceptedByViewer = (boardId: string): BoardInviteAcceptedByViewer => ({
  type: 'BOARD_INVITE_ACCEPTED_BY_VIEWER',
  payload: {
    boardId,
  },
});

export type BoardCoverImageUpdate = {
  type: 'BOARD_COVER_IMAGE_UPDATED',
  payload: {
    boardId: string,
    coverPin: {
      custom_cover: boolean,
      scale: number,
      pin_id: string,
      crop: ImagePositionType,
      image_url: string,
    },
  },
};

export const boardCoverImageUpdated = (
  boardId: string,
  coverPin: {
    custom_cover: boolean,
    scale: number,
    pin_id: string,
    crop: ImagePositionType,
    image_url: string,
  },
) => ({
  type: 'BOARD_COVER_IMAGE_UPDATED',
  payload: {
    boardId,
    coverPin,
  },
});

export type BoardDisableMoreIdeasBadging = {|
  type: 'BOARD_DISABLE_MORE_IDEAS_BADGING',
  payload: {
    boardId: string,
  },
|};

export const boardDisableMoreIdeasBadging = (boardId: string): BoardDisableMoreIdeasBadging => ({
  type: 'BOARD_DISABLE_MORE_IDEAS_BADGING',
  payload: {
    boardId,
  },
});
